import { BfxBlotterOrdersContextMenuActionPayload } from "./BfxBlotterOrdersContextMenuActionPayload";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuItemTakeState extends ContextMenuItemState {
  public clientCode: string = null;

  constructor(
    public count: number = 0,
    itemIndex: number = 0,
    available: boolean = true,
    enabled: boolean = true,
    title: string = "",
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
